import { render } from "./CardCost.vue?vue&type=template&id=73c31344&ts=true"
import script from "./CardCost.vue?vue&type=script&lang=ts"
export * from "./CardCost.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__